import Vue from "vue";
import PageView from "./PageView";
import Row from "./Row";
import cCol from "./cCol";
import TitleView from "./TitleView";
import BlockLine from "./BlockLine";
import SmartInput from "./SmartInput";
import SelectObjectAutocomplete from "./SelectObjectAutocomplete";
import MessageBox from "./MessageBox";
import PopupDialog from "./PopupDialog";
import EditBtn from "./EditBtn";
import RemoveBtn from "./RemoveBtn";
import ColsRow from "./ColsRow";
import cCard from "./cCard";

export default {
  PageView,
  Row,
  BlockLine,
  TitleView,
  cCol,
  SmartInput,
  MessageBox,
};

Vue.component("Page", PageView);
Vue.component("c-card", cCard);
Vue.component("Row", Row);
Vue.component("ColsRow", ColsRow);
Vue.component("TitleView", TitleView);
Vue.component("BlockLine", BlockLine);
Vue.component("SmartInput", SmartInput);
Vue.component("SelectObjectAutocomplete", SelectObjectAutocomplete);
Vue.component("CCol", cCol);
Vue.component("MessageBox", MessageBox);
Vue.component("PopupDialog", PopupDialog);
Vue.component("EditBtn", EditBtn);
Vue.component("RemoveBtn", RemoveBtn);
